module.exports = __webpack_public_path__ + "img/icon-three.49d44aa8.svg";